import React, { useState } from 'react';
import { Route as ReactRoute, Redirect as ReactRedirect } from 'react-router-dom';
import { jwtDecode } from 'jwt-decode';
import useSWR from 'swr';

import CircularProgress from '@mui/material/CircularProgress';

import axiosInstance from 'utils/interceptors';

const Route = ({ component: Component, ...rest }) => {  
  const [time] = useState(Date.now());

  const fetcher = url => axiosInstance.get(url, { headers: { Authorization: `Bearer ${localStorage.getItem('JWT_TOKEN')}`}}).then(res => res.data);
  const { data: auth, isLoading: loadingAuth } = useSWR(`${process.env.REACT_APP_CLOUD_CONNECT_API}/me?_=${time}`, fetcher);

  const handlePermission = props => {
    const { isPublic, permissions } = rest;

    if (isPublic) {
      return <Component {...props} />;
    }

    if (loadingAuth) {
      return (
        <div className='text-white text-center mt-20'>
          <CircularProgress />
          <div className='mt-4'>Loading ...</div>
        </div>
      )
    }

    if (!auth) {
      return <ReactRedirect to={{ pathname: '/forbidden' }} />;
    }

    if (permissions?.length > 0) {
      const token = localStorage.getItem('JWT_TOKEN');
      const decoded = jwtDecode(token);
      const permissionsArray = permissions.map(item => decoded.pe[item]);

      if (permissionsArray.includes(false)) {
        return <ReactRedirect to={{ pathname: '/forbidden' }} />;
      }

      return <Component {...props} />;
    }

    return <Component {...props} />;
  };

  return <ReactRoute {...rest} render={props => handlePermission(props)} />;
};

export default Route;